import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";

const mintIcon = L.divIcon({
  className: "",
  html: `<div style="width:28px;height:28px;border-radius:50% 50% 50% 0;background:#10B981;transform:rotate(-45deg);border:3px solid #fff;box-shadow:0 3px 8px rgba(15,23,42,0.4);display:flex;align-items:center;justify-content:center"><div style="width:9px;height:9px;border-radius:50%;background:#fff;transform:rotate(45deg)"></div></div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 28],
});

export default function MapPin({ lat, lng, height = 140, zoom = 16, rounded = 12 }) {
  if (lat == null || lng == null) return null;
  return (
    <div style={{ height, borderRadius: rounded, overflow: "hidden", border: "1px solid #E5E7EB" }}>
      <MapContainer
        center={[lat, lng]}
        zoom={zoom}
        scrollWheelZoom={false}
        dragging={false}
        doubleClickZoom={false}
        zoomControl={false}
        attributionControl={false}
        style={{ height: "100%", width: "100%", background: "#F1F5F9" }}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" subdomains="abc" detectRetina={true} />
        <Marker position={[lat, lng]} icon={mintIcon} />
      </MapContainer>
    </div>
  );
}
